import { ServicesCategoryValues } from '@/components/forms/form-services-category/FormServicesCategory';
import api from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const usePatchSports = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ['patchSport'],
    mutationFn: (data: {
      payload: Partial<ServicesCategoryValues>;
      sportId: string;
    }) => {
      return api.sports.patchSports(data.payload, data.sportId);
    },
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === 'sport' ||
          query.queryKey[0] === 'sports'
      });
      toast.success(t('toast.categoryUpdated'));
      navigate(-1);
    },
    retry: false
  });
};

export default usePatchSports;
